(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jhny-product-specifications"] && !Shopify.designMode) return;
  try {
    (() => {
    const updateSpecifications = (container, unit) => {
      container.dataset.unit = unit;

      container.querySelectorAll('[data-unit-button]').forEach((button) => {
        const isActive = button.dataset.unitButton === unit;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });

      container.querySelectorAll('[data-measurement-value]').forEach((value) => {
        const number = Number(value.dataset[unit]);
        value.textContent = Number.isFinite(number) ? number.toFixed(2) : value.dataset[unit];
      });

      container.querySelectorAll('[data-unit-label]').forEach((label) => {
        label.textContent = unit;
      });
    };

    const initializeSpecifications = (root = document) => {
      root.querySelectorAll('[data-jhny-specifications]').forEach((container) => {
        updateSpecifications(container, container.dataset.unit || 'in');
      });
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-unit-button]');
      if (!button) return;

      const container = button.closest('[data-jhny-specifications]');
      if (container) updateSpecifications(container, button.dataset.unitButton);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeSpecifications());
    } else {
      initializeSpecifications();
    }

    document.addEventListener('shopify:section:load', (event) => initializeSpecifications(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jhny-wall-preview"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('jhny-wall-preview')) return;

    const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

    class JhnyWallPreview extends HTMLElement {
      constructor() {
        super();
        this.stream = null;
        this.xrSession = null;
        this.hitTestSource = null;
        this.referenceSpace = null;
        this.currentHitMatrix = null;
        this.lockedHitMatrix = null;
        this.pointers = new Map();
        this.position = { x: 0, y: 0 };
        this.scale = 1;
        this.startScale = 1;
        this.startDistance = 0;
        this.dragStart = null;
        this.objectUrl = '';
        this.cleanObjectUrl = '';
        this.cleanArtworkCanvas = null;
        this.cleanFrameCanvas = null;
        this.frameOpening = null;
        this.compositeCanvas = null;
        this.compositeArtworkRect = null;
      }

      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.dialog = this.querySelector('[data-jhny-wall-dialog]');
        this.intro = this.querySelector('[data-jhny-wall-intro]');
        this.experience = this.querySelector('[data-jhny-wall-experience]');
        this.video = this.querySelector('[data-jhny-wall-video]');
        this.xrCanvas = this.querySelector('[data-jhny-wall-xr]');
        this.art = this.querySelector('[data-jhny-wall-art]');
        this.artImage = this.querySelector('[data-jhny-wall-art-image]');
        this.status = this.querySelector('[data-jhny-wall-status]');
        this.sizeLabel = this.querySelector('[data-jhny-wall-size]');
        this.controls = this.querySelector('[data-jhny-wall-controls]');
        this.querySelector('[data-jhny-wall-open]').addEventListener('click', () => this.open());
        this.querySelector('[data-jhny-wall-start]').addEventListener('click', () => this.start());
        this.querySelector('[data-jhny-wall-close]').addEventListener('click', () => this.close());
        this.querySelector('[data-jhny-wall-cancel]').addEventListener('click', () => this.close());
        this.querySelector('[data-jhny-wall-smaller]').addEventListener('click', () => this.resize(-.1));
        this.querySelector('[data-jhny-wall-larger]').addEventListener('click', () => this.resize(.1));
        this.querySelector('[data-jhny-wall-capture]').addEventListener('click', () => this.capture());
        this.art.addEventListener('pointerdown', event => this.pointerDown(event));
        this.art.addEventListener('pointermove', event => this.pointerMove(event));
        this.art.addEventListener('pointerup', event => this.pointerUp(event));
        this.art.addEventListener('pointercancel', event => this.pointerUp(event));
        this.dialog.addEventListener('cancel', event => {
          event.preventDefault();
          this.close();
        });
        document.addEventListener('visibilitychange', () => {
          if (document.hidden && this.dialog.open) this.stopMedia();
        });
      }

      section() {
        return this.closest('.shopify-section') || this.closest('[id^="MainProduct-"]') || document;
      }

      open() {
        this.reset();
        this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
      }

      close() {
        this.stopMedia();
        this.releaseArtwork();
        if (this.dialog.open) this.dialog.close();
        document.documentElement.style.removeProperty('overflow');
        this.reset();
      }

      reset() {
        this.intro.hidden = false;
        this.experience.hidden = true;
        this.classList.remove('jhny-wall-preview--xr');
        this.status.textContent = '';
        this.position = { x: 0, y: 0 };
        this.scale = 1;
        this.updateTransform();
      }

      stopMedia() {
        if (this.stream) {
          this.stream.getTracks().forEach(track => track.stop());
          this.stream = null;
        }
        this.video.srcObject = null;
        if (this.xrSession) {
          const session = this.xrSession;
          this.xrSession = null;
          session.end().catch(() => {});
        }
        if (this.hitTestSource) {
          this.hitTestSource.cancel();
          this.hitTestSource = null;
        }
        this.lockedHitMatrix = null;
        this.currentHitMatrix = null;
      }

      releaseArtwork() {
        if (this.cleanObjectUrl) URL.revokeObjectURL(this.cleanObjectUrl);
        this.cleanObjectUrl = '';
        this.cleanArtworkCanvas = null;
        this.cleanFrameCanvas = null;
        this.frameOpening = null;
        this.compositeCanvas = null;
        this.compositeArtworkRect = null;
        this.artImage.removeAttribute('src');
      }

      parseDimensions(value) {
        const match = String(value || '').replace(/,/g, '.').match(/(\d+(?:\.\d+)?)\s*(?:["″]|in(?:ches)?|cm)?\s*[x×]\s*(\d+(?:\.\d+)?)/i);
        if (!match) return null;
        const width = Number(match[1]);
        const height = Number(match[2]);
        if (!width || !height) return null;
        return { width, height };
      }

      selectedDimensions() {
        const controls = this.section().querySelectorAll("variant-selects select, variant-radios input[type='radio'], select[name^='options'], input[type='radio'][name^='options']");
        let fallback = null;
        for (const control of controls) {
          const dimensions = control.tagName === 'SELECT' ? this.parseDimensions(control.value) : control.checked ? this.parseDimensions(control.value) : null;
          if (!dimensions) continue;
          if (!fallback) fallback = dimensions;
          if (control.getClientRects().length && control.getBoundingClientRect().width > 0) return dimensions;
        }
        return fallback || { width: 24, height: 32 };
      }

      selectedFrame() {
        const section = this.section();
        if (section.dataset.jhnyFrameNone === 'true') return { id: 'none', source: '' };
        const roots = this.section().querySelectorAll('[data-jhny-frame]');
        let selectedId = section.dataset.jhnyFrameCurrent || '';
        for (const root of roots) {
          if (!root.getClientRects().length) continue;
          const active = root.querySelector('.jhny-frame__option.is-active, .jhny-frame__option[aria-pressed="true"]');
          if (active) {
            selectedId = active.dataset.frameId || selectedId;
            if (selectedId === 'none') return { id: 'none', source: '' };
            if (active.dataset.frameSrc) return { id: selectedId, source: active.dataset.frameSrc };
          }
        }
        if (!selectedId || selectedId === 'none') selectedId = 'natural';
        for (const root of roots) {
          const button = root.querySelector(`.jhny-frame__option[data-frame-id="${selectedId}"]`);
          if (button && button.dataset.frameSrc) return { id: selectedId, source: button.dataset.frameSrc };
        }
        return { id: selectedId, source: '' };
      }

      ratioKey(dimensions) {
        const value = dimensions.width / dimensions.height;
        const definitions = [
          ['1x1', 1], ['4x5', 4 / 5], ['3x4', 3 / 4], ['2x3', 2 / 3],
          ['5x4', 5 / 4], ['4x3', 4 / 3], ['3x2', 3 / 2]
        ];
        let match = definitions[0];
        for (const definition of definitions) {
          if (Math.abs(definition[1] - value) < Math.abs(match[1] - value)) match = definition;
        }
        return match[0];
      }

      selectedImageSource(dimensions) {
        const wrapper = this.section().querySelector('.product__media-wrapper');
        const ratioRoot = wrapper && wrapper.querySelector('[data-jhny-ratio-preview]');
        if (ratioRoot) {
          const ratio = ratioRoot.dataset.jhnyActiveRatio || this.ratioKey(dimensions);
          const ratioSource = ratioRoot.getAttribute(`data-src-${ratio}`);
          if (ratioSource) return ratioSource;
        }
        const selectors = [
          '.jhny-ratio-preview-image.is-visible',
          '.product__media-list .swiper-slide-active .product__media img:not(.jhny-artframe-img)',
          '.product__media-list .product__media img:not(.jhny-artframe-img)'
        ];
        for (const selector of selectors) {
          const image = wrapper && wrapper.querySelector(selector);
          if (image) return image.currentSrc || image.src;
        }
        return '';
      }

      async prepareArtwork() {
        this.releaseArtwork();
        this.dimensions = this.selectedDimensions();
        const selectedFrame = this.selectedFrame();
        this.frame = selectedFrame.id;
        const ratioKey = this.ratioKey(this.dimensions);
        this.frameSource = selectedFrame.source
          ? selectedFrame.source.replace(/-(?:1x1|4x5|3x4|2x3|5x4|4x3|3x2)(?=_)/, `-${ratioKey}`)
          : '';
        this.source = this.selectedImageSource(this.dimensions);
        this.cleanArtworkCanvas = await this.createCleanArtwork(this.source, this.dimensions);
        if (this.frame !== 'none' && this.frameSource) {
          this.cleanFrameCanvas = await this.createCleanFrame(this.frameSource, ratioKey);
        }
        const composite = await this.buildComposite();
        const blob = await new Promise(resolve => composite.toBlob(resolve, 'image/png'));
        if (!blob) throw new Error('artwork');
        this.cleanObjectUrl = URL.createObjectURL(blob);
        this.artImage.src = this.cleanObjectUrl;
        this.art.style.aspectRatio = `${composite.width} / ${composite.height}`;
        this.art.style.width = this.dimensions.width >= this.dimensions.height ? 'min(62vw, 520px)' : 'min(50vw, 360px)';
        this.art.dataset.frame = this.frame;
        this.sizeLabel.textContent = `${this.dataset.selectedSize}: ${this.dimensions.width} × ${this.dimensions.height} in · ${this.dataset.approximate}`;
      }

      async start() {
        this.intro.hidden = true;
        this.experience.hidden = false;
        this.status.textContent = this.dataset.loading;
        try {
          await this.prepareArtwork();
        } catch (error) {
          this.status.textContent = this.dataset.cameraError;
          return;
        }
        try {
          if (navigator.xr && await navigator.xr.isSessionSupported('immersive-ar')) {
            await this.startXR();
            return;
          }
        } catch (error) {
          this.classList.remove('jhny-wall-preview--xr');
        }
        await this.startCamera();
      }

      async startCamera() {
        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
          this.status.textContent = this.dataset.cameraError;
          return;
        }
        try {
          this.stream = await navigator.mediaDevices.getUserMedia({
            audio: false,
            video: { facingMode: { ideal: 'environment' }, width: { ideal: 1920 }, height: { ideal: 1080 } }
          });
          this.video.srcObject = this.stream;
          await this.video.play();
          this.status.textContent = this.dataset.cameraHint;
        } catch (error) {
          this.status.textContent = this.dataset.cameraError;
        }
      }

      async startXR() {
        const composite = await this.buildComposite();
        const session = await navigator.xr.requestSession('immersive-ar', {
          requiredFeatures: ['hit-test'],
          optionalFeatures: ['local-floor', 'dom-overlay'],
          domOverlay: { root: this.dialog }
        });
        this.xrSession = session;
        this.classList.add('jhny-wall-preview--xr');
        this.status.textContent = this.dataset.arHint;
        const gl = this.xrCanvas.getContext('webgl', { xrCompatible: true, alpha: true, antialias: true });
        await gl.makeXRCompatible();
        session.updateRenderState({ baseLayer: new XRWebGLLayer(session, gl) });
        this.referenceSpace = await session.requestReferenceSpace('local');
        const viewerSpace = await session.requestReferenceSpace('viewer');
        this.hitTestSource = await session.requestHitTestSource({ space: viewerSpace });
        const renderer = this.createXRRenderer(gl, composite);
        session.addEventListener('select', () => {
          if (this.currentHitMatrix) this.lockedHitMatrix = new Float32Array(this.currentHitMatrix);
        });
        session.addEventListener('end', () => {
          this.xrSession = null;
          this.hitTestSource = null;
          this.classList.remove('jhny-wall-preview--xr');
          if (this.dialog.open) this.close();
        }, { once: true });
        const frameLoop = (time, frame) => {
          if (!this.xrSession) return;
          const pose = frame.getViewerPose(this.referenceSpace);
          const hits = this.hitTestSource ? frame.getHitTestResults(this.hitTestSource) : [];
          if (!this.lockedHitMatrix && hits.length) {
            const hitPose = hits[0].getPose(this.referenceSpace);
            if (hitPose) this.currentHitMatrix = hitPose.transform.matrix;
          }
          const model = this.lockedHitMatrix || this.currentHitMatrix;
          renderer.render(frame, pose, model, this.dimensions);
          this.xrSession.requestAnimationFrame(frameLoop);
        };
        session.requestAnimationFrame(frameLoop);
      }

      createXRRenderer(gl, textureCanvas) {
        const vertexSource = 'attribute vec2 a_position;attribute vec2 a_uv;uniform mat4 u_projection;uniform mat4 u_view;uniform mat4 u_model;uniform vec2 u_size;varying vec2 v_uv;void main(){vec4 local=vec4(a_position.x*u_size.x,.002,-a_position.y*u_size.y,1.);gl_Position=u_projection*u_view*u_model*local;v_uv=a_uv;}';
        const fragmentSource = 'precision mediump float;uniform sampler2D u_texture;varying vec2 v_uv;void main(){gl_FragColor=texture2D(u_texture,v_uv);}';
        const compile = (type, source) => {
          const shader = gl.createShader(type);
          gl.shaderSource(shader, source);
          gl.compileShader(shader);
          if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) throw new Error(gl.getShaderInfoLog(shader));
          return shader;
        };
        const program = gl.createProgram();
        gl.attachShader(program, compile(gl.VERTEX_SHADER, vertexSource));
        gl.attachShader(program, compile(gl.FRAGMENT_SHADER, fragmentSource));
        gl.linkProgram(program);
        if (!gl.getProgramParameter(program, gl.LINK_STATUS)) throw new Error(gl.getProgramInfoLog(program));
        const buffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
        gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-.5,-.5,0,1,.5,-.5,1,1,-.5,.5,0,0,-.5,.5,0,0,.5,-.5,1,1,.5,.5,1,0]), gl.STATIC_DRAW);
        const texture = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, texture);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, true);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, textureCanvas);
        gl.enable(gl.BLEND);
        gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
        gl.useProgram(program);
        const position = gl.getAttribLocation(program, 'a_position');
        const uv = gl.getAttribLocation(program, 'a_uv');
        gl.enableVertexAttribArray(position);
        gl.vertexAttribPointer(position, 2, gl.FLOAT, false, 16, 0);
        gl.enableVertexAttribArray(uv);
        gl.vertexAttribPointer(uv, 2, gl.FLOAT, false, 16, 8);
        const projection = gl.getUniformLocation(program, 'u_projection');
        const view = gl.getUniformLocation(program, 'u_view');
        const modelLocation = gl.getUniformLocation(program, 'u_model');
        const size = gl.getUniformLocation(program, 'u_size');
        return {
          render: (frame, pose, model, dimensions) => {
            const layer = frame.session.renderState.baseLayer;
            gl.bindFramebuffer(gl.FRAMEBUFFER, layer.framebuffer);
            gl.clearColor(0, 0, 0, 0);
            gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
            if (!pose || !model) return;
            const outerWidth = dimensions.width * textureCanvas.width / this.compositeArtworkRect.width;
            const outerHeight = dimensions.height * textureCanvas.height / this.compositeArtworkRect.height;
            gl.uniform2f(size, outerWidth * .0254, outerHeight * .0254);
            gl.uniformMatrix4fv(modelLocation, false, model);
            for (const xrView of pose.views) {
              const viewport = layer.getViewport(xrView);
              gl.viewport(viewport.x, viewport.y, viewport.width, viewport.height);
              gl.uniformMatrix4fv(projection, false, xrView.projectionMatrix);
              gl.uniformMatrix4fv(view, false, xrView.transform.inverse.matrix);
              gl.drawArrays(gl.TRIANGLES, 0, 6);
            }
          }
        };
      }

      loadImage(source) {
        return new Promise((resolve, reject) => {
          const image = new Image();
          image.crossOrigin = 'anonymous';
          image.onload = () => resolve(image);
          image.onerror = reject;
          image.src = source;
        });
      }

      cropToAspect(width, height, targetRatio) {
        const sourceRatio = width / height;
        if (sourceRatio > targetRatio) {
          const cropWidth = height * targetRatio;
          return { x: (width - cropWidth) / 2, y: 0, width: cropWidth, height };
        }
        const cropHeight = width / targetRatio;
        return { x: 0, y: (height - cropHeight) / 2, width, height: cropHeight };
      }

      detectArtworkBounds(image, targetRatio) {
        const analysisWidth = Math.min(1200, image.naturalWidth);
        const analysisHeight = Math.max(1, Math.round(analysisWidth * image.naturalHeight / image.naturalWidth));
        const canvas = document.createElement('canvas');
        canvas.width = analysisWidth;
        canvas.height = analysisHeight;
        const context = canvas.getContext('2d', { willReadFrequently: true });
        context.drawImage(image, 0, 0, analysisWidth, analysisHeight);
        const pixels = context.getImageData(0, 0, analysisWidth, analysisHeight).data;
        const cornerCoordinates = [
          [1, 1], [analysisWidth - 2, 1],
          [1, analysisHeight - 2], [analysisWidth - 2, analysisHeight - 2]
        ];
        const corners = cornerCoordinates.map(([x, y]) => {
          const index = (y * analysisWidth + x) * 4;
          return [pixels[index], pixels[index + 1], pixels[index + 2], pixels[index + 3]];
        });
        const transparentBackground = corners.every(corner => corner[3] < 18);
        if (!transparentBackground && Math.abs(image.naturalWidth / image.naturalHeight - targetRatio) <= .025) return null;
        let minX = analysisWidth;
        let minY = analysisHeight;
        let maxX = -1;
        let maxY = -1;
        for (let y = 0; y < analysisHeight; y += 1) {
          for (let x = 0; x < analysisWidth; x += 1) {
            const index = (y * analysisWidth + x) * 4;
            const alpha = pixels[index + 3];
            if (alpha < (transparentBackground ? 128 : 18)) continue;
            let backgroundDistance = Infinity;
            for (const corner of corners) {
              const red = pixels[index] - corner[0];
              const green = pixels[index + 1] - corner[1];
              const blue = pixels[index + 2] - corner[2];
              backgroundDistance = Math.min(backgroundDistance, Math.sqrt(red * red + green * green + blue * blue));
            }
            const isInterior = transparentBackground || alpha < 250 || backgroundDistance > 34;
            if (!isInterior) continue;
            minX = Math.min(minX, x);
            minY = Math.min(minY, y);
            maxX = Math.max(maxX, x);
            maxY = Math.max(maxY, y);
          }
        }
        if (maxX < minX || maxY < minY) return null;
        const width = maxX - minX + 1;
        const height = maxY - minY + 1;
        const candidateRatio = width / height;
        const area = width * height / (analysisWidth * analysisHeight);
        if (area < .08 || Math.abs(candidateRatio - targetRatio) > .18) return null;
        const scaleX = image.naturalWidth / analysisWidth;
        const scaleY = image.naturalHeight / analysisHeight;
        return {
          x: minX * scaleX,
          y: minY * scaleY,
          width: width * scaleX,
          height: height * scaleY
        };
      }

      async createCleanArtwork(source, dimensions) {
        const image = await this.loadImage(source);
        const targetRatio = dimensions.width / dimensions.height;
        const outputWidth = targetRatio >= 1 ? 1200 : Math.round(1200 * targetRatio);
        const outputHeight = targetRatio >= 1 ? Math.round(1200 / targetRatio) : 1200;
        const canvas = document.createElement('canvas');
        canvas.width = outputWidth;
        canvas.height = outputHeight;
        const context = canvas.getContext('2d');
        let crop = this.detectArtworkBounds(image, targetRatio);
        if (!crop) crop = this.cropToAspect(image.naturalWidth, image.naturalHeight, targetRatio);
        context.clearRect(0, 0, outputWidth, outputHeight);
        context.drawImage(image, crop.x, crop.y, crop.width, crop.height, 0, 0, outputWidth, outputHeight);
        return canvas;
      }

      async createCleanFrame(source, ratioKey) {
        const openings = {
          '1x1': [216, 202, 783, 794],
          '4x5': [284, 201, 634, 798],
          '3x4': [305, 201, 593, 798],
          '2x3': [339, 201, 525, 798],
          '5x4': [201, 284, 798, 634],
          '4x3': [201, 305, 798, 593],
          '3x2': [202, 332, 798, 537]
        };
        const opening = openings[ratioKey];
        if (!opening) throw new Error('frame dimensions');
        const image = await this.loadImage(source);
        const sourceCanvas = document.createElement('canvas');
        sourceCanvas.width = image.naturalWidth;
        sourceCanvas.height = image.naturalHeight;
        const context = sourceCanvas.getContext('2d', { willReadFrequently: true });
        context.drawImage(image, 0, 0);
        const data = context.getImageData(0, 0, sourceCanvas.width, sourceCanvas.height);
        let left = sourceCanvas.width;
        let top = sourceCanvas.height;
        let right = -1;
        let bottom = -1;
        for (let y = 0; y < sourceCanvas.height; y++) {
          for (let x = 0; x < sourceCanvas.width; x++) {
            const alpha = (y * sourceCanvas.width + x) * 4 + 3;
            if (data.data[alpha] < 128) {
              data.data[alpha] = 0;
              continue;
            }
            left = Math.min(left, x);
            top = Math.min(top, y);
            right = Math.max(right, x);
            bottom = Math.max(bottom, y);
          }
        }
        if (right < left || bottom < top) throw new Error('empty frame');
        context.putImageData(data, 0, 0);
        const scaleX = sourceCanvas.width / 1200;
        const scaleY = sourceCanvas.height / 1200;
        this.frameOpening = {
          x: opening[0] * scaleX - left,
          y: opening[1] * scaleY - top,
          width: opening[2] * scaleX,
          height: opening[3] * scaleY
        };
        const canvas = document.createElement('canvas');
        canvas.width = right - left + 1;
        canvas.height = bottom - top + 1;
        canvas.getContext('2d').drawImage(sourceCanvas, left, top, canvas.width, canvas.height, 0, 0, canvas.width, canvas.height);
        return canvas;
      }

      async buildComposite() {
        if (this.compositeCanvas) return this.compositeCanvas;
        const ratio = this.dimensions.width / this.dimensions.height;
        const artWidth = ratio >= 1 ? 1024 : Math.round(1024 * ratio);
        const artHeight = ratio >= 1 ? Math.round(1024 / ratio) : 1024;
        const canvas = document.createElement('canvas');
        let artwork = { x: 0, y: 0, width: artWidth, height: artHeight };
        if (this.frame !== 'none' && this.cleanFrameCanvas && this.frameOpening) {
          const scaleX = artWidth / this.frameOpening.width;
          const scaleY = artHeight / this.frameOpening.height;
          canvas.width = Math.ceil(this.cleanFrameCanvas.width * scaleX);
          canvas.height = Math.ceil(this.cleanFrameCanvas.height * scaleY);
          artwork.x = this.frameOpening.x / this.cleanFrameCanvas.width * canvas.width;
          artwork.y = this.frameOpening.y / this.cleanFrameCanvas.height * canvas.height;
          artwork.width = this.frameOpening.width / this.cleanFrameCanvas.width * canvas.width;
          artwork.height = this.frameOpening.height / this.cleanFrameCanvas.height * canvas.height;
        } else {
          canvas.width = artWidth;
          canvas.height = artHeight;
        }
        const context = canvas.getContext('2d');
        context.drawImage(this.cleanArtworkCanvas, artwork.x, artwork.y, artwork.width, artwork.height);
        if (this.frame !== 'none' && this.cleanFrameCanvas) {
          context.drawImage(this.cleanFrameCanvas, 0, 0, canvas.width, canvas.height);
        }
        this.compositeArtworkRect = artwork;
        this.compositeCanvas = canvas;
        return canvas;
      }

      pointerDown(event) {
        this.art.setPointerCapture(event.pointerId);
        this.pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
        if (this.pointers.size === 1) this.dragStart = { x: event.clientX - this.position.x, y: event.clientY - this.position.y };
        if (this.pointers.size === 2) {
          const points = [...this.pointers.values()];
          this.startDistance = Math.hypot(points[1].x - points[0].x, points[1].y - points[0].y);
          this.startScale = this.scale;
        }
      }

      pointerMove(event) {
        if (!this.pointers.has(event.pointerId)) return;
        this.pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
        if (this.pointers.size === 1 && this.dragStart) {
          this.position.x = event.clientX - this.dragStart.x;
          this.position.y = event.clientY - this.dragStart.y;
        } else if (this.pointers.size === 2) {
          const points = [...this.pointers.values()];
          const distance = Math.hypot(points[1].x - points[0].x, points[1].y - points[0].y);
          this.scale = clamp(this.startScale * distance / this.startDistance, .45, 2.4);
        }
        this.updateTransform();
      }

      pointerUp(event) {
        this.pointers.delete(event.pointerId);
        if (this.pointers.size < 2) this.startDistance = 0;
        if (!this.pointers.size) this.dragStart = null;
      }

      resize(amount) {
        this.scale = clamp(this.scale + amount, .45, 2.4);
        this.updateTransform();
      }

      updateTransform() {
        if (!this.art) return;
        this.art.style.transform = `translate(-50%, -50%) translate(${this.position.x}px, ${this.position.y}px) scale(${this.scale})`;
      }

      async capture() {
        if (!this.stream || !this.video.videoWidth) return;
        this.status.textContent = this.dataset.saving;
        try {
          const stage = this.experience.getBoundingClientRect();
          const aspect = stage.width / stage.height;
          const outputWidth = Math.min(1600, this.video.videoWidth);
          const outputHeight = Math.round(outputWidth / aspect);
          const canvas = document.createElement('canvas');
          canvas.width = outputWidth;
          canvas.height = outputHeight;
          const context = canvas.getContext('2d');
          const videoAspect = this.video.videoWidth / this.video.videoHeight;
          let sourceX = 0;
          let sourceY = 0;
          let sourceWidth = this.video.videoWidth;
          let sourceHeight = this.video.videoHeight;
          if (videoAspect > aspect) {
            sourceWidth = this.video.videoHeight * aspect;
            sourceX = (this.video.videoWidth - sourceWidth) / 2;
          } else {
            sourceHeight = this.video.videoWidth / aspect;
            sourceY = (this.video.videoHeight - sourceHeight) / 2;
          }
          context.drawImage(this.video, sourceX, sourceY, sourceWidth, sourceHeight, 0, 0, outputWidth, outputHeight);
          const composite = await this.buildComposite();
          const artRect = this.art.getBoundingClientRect();
          const scaleX = outputWidth / stage.width;
          const scaleY = outputHeight / stage.height;
          context.drawImage(composite, (artRect.left - stage.left) * scaleX, (artRect.top - stage.top) * scaleY, artRect.width * scaleX, artRect.height * scaleY);
          const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/jpeg', .92));
          if (!blob) throw new Error('capture');
          const safeTitle = (this.dataset.productTitle || 'wall-art').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
          const file = new File([blob], `${safeTitle || 'wall-art'}-on-my-wall.jpg`, { type: 'image/jpeg' });
          if (navigator.share && navigator.canShare && navigator.canShare({ files: [file] })) {
            await navigator.share({ files: [file], title: this.dataset.shareTitle });
          } else {
            if (this.objectUrl) URL.revokeObjectURL(this.objectUrl);
            this.objectUrl = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = this.objectUrl;
            link.download = file.name;
            link.click();
          }
          this.status.textContent = this.dataset.cameraHint;
        } catch (error) {
          this.status.textContent = this.dataset.cameraHint;
        }
      }
    }

    customElements.define('jhny-wall-preview', JhnyWallPreview);
  })();
  } catch(e) { console.error(e); }
})();

})();
